import { styled } from 'styled-components';

export default styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  
  padding-left: 1rem;

  font-family: 'Sanko';
  font-size: 3rem;

  @media only screen and (max-width: 720px) {
    font-size: 1.5rem;   
  }
`;
